class ZerraLedButton {
  constructor(el) {
    this.el = el;
    this.onMove = this.onMove.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.el.addEventListener('mousemove', this.onMove);
    this.el.addEventListener('mouseenter', this.onEnter);
    this.el.addEventListener('mouseleave', this.onLeave);
  }

  onMove(e) {
    const rect = this.el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    this.el.style.setProperty('--x', `${x}%`);
    this.el.style.setProperty('--y', `${y}%`);
  }

  onEnter() {
    this.el.classList.add('is-hovering');
  }

  onLeave() {
    this.el.classList.remove('is-hovering');
    this.el.style.setProperty('--x', '50%');
    this.el.style.setProperty('--y', '50%');
  }
}

function initZerraLedButtons(root = document) {
  root.querySelectorAll('.zerra-led-btn:not([data-led-init])').forEach((btn) => {
    btn.setAttribute('data-led-init', 'true');
    new ZerraLedButton(btn);
  });
}

window.initZerraLedButtons = initZerraLedButtons;

document.addEventListener('DOMContentLoaded', () => initZerraLedButtons());

if (document.readyState !== 'loading') {
  initZerraLedButtons();
}

document.addEventListener('shopify:section:load', (e) => initZerraLedButtons(e.target));
